import {
  QueryFunctionContext,
  UseInfiniteQueryOptions
} from '@tanstack/react-query';
import { axiosHelper } from '@setvi/shared/services';
import { AxiosMethods, CompetitorsApi } from '@setvi/shared/enums';
import { CompetitorFilters, CompetitorResponse } from './Types';

export enum CompetitorsQueryKey {
  GET_COMPETITORS = 'GET_COMPETITORS',
  GET_COMPETITOR = 'GET_COMPETITOR'
}

export const getCompetitorsQuery = (
  params: CompetitorFilters
): UseInfiniteQueryOptions<CompetitorResponse> => ({
  queryKey: [CompetitorsQueryKey.GET_COMPETITORS, params],
  queryFn: (data: QueryFunctionContext) =>
    axiosHelper({
      endpoint: CompetitorsApi.GetCompetitors,
      method: AxiosMethods.GET,
      params: {
        ...params,
        page: data.pageParam || params.page
      },
      baseURL: process.env.REVOPS_API
    }),
  getNextPageParam: (lastPage: CompetitorResponse) => {
    const total = lastPage?.total;
    const currPage = lastPage.page || 1;
    const currSize = lastPage.limit || 10;

    return currPage * currSize >= total ? undefined : currPage + 1;
  },
  refetchOnWindowFocus: false,
  cacheTime: 0
});

export const getCompetitorQuery = (id: string) => ({
  queryKey: [CompetitorsQueryKey.GET_COMPETITORS],
  queryFn: () =>
    axiosHelper({
      endpoint: CompetitorsApi.GetCompetitor.replace(':id', id),
      method: AxiosMethods.GET
    }),
  cacheTime: 0
});
